import { styled } from '@mui/material'
import { Box } from '@mui/material'

export const ContainerSwapStyled = styled(Box)(() => ({
  display: 'flex',
  gap: '24px',
}))
